/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/objectSpread";
import _objectWithoutProperties from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/objectWithoutProperties";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import config from '@/const/config';
import { request } from '@/utils';
var switchApi = config.switchApi; // switchApi = 'https://fat-switchpowerapi.hellobike.com/api';

export function getActivity(_ref) {
  var activityId = _ref.activityId,
      params = _objectWithoutProperties(_ref, ["activityId"]);

  return request.post(switchApi, _objectSpread({
    activityId: activityId
  }, params, {
    action: 'switchpower.promotion.activity.showCoupon'
  }), {
    ignoreLogin: true
  }).then(function (res) {
    return res.obj;
  });
}
/**
 * 领取优惠券并绑定关系
 * @param {params} params 入参
 */

export function receiveCouponAndBinding(params) {
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchpower.promotion.activity.receiveCouponAndBinding'
  })).then(function (res) {
    return res.data;
  });
}
/**
 * 获取队长绩效
 */

export function getLeaderPerformance(params) {
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchPower.promotion.performance.leader'
  })).then(function (res) {
    return res.data;
  });
}
/**
 * 获取队员绩效
 */

export function getMemberPerformance(params) {
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchPower.promotion.performance.member'
  })).then(function (res) {
    return res.data;
  });
}
/**
 * 获取绩效统计
 */

export function getStatis(params) {
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchPower.promotion.performance.statis'
  })).then(function (res) {
    return res.data;
  });
}